import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import axios, { Axios } from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { variables } from './Variables.js';
import { FALSE } from 'sass';


import Tennis_Main_Ar from './Tennis_Main_Ar.js';





export default function Tennis_Home_Ar() {
  const jsonbasket = variables.basename_url + 'updates/index/Athlethixnet_HomeAr_Tennis.json';

  const [isLoading, setNisLoading] = useState(false);
  const navigate = useNavigate();
  const usenavigate = useNavigate();


  async function refda() {

    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    //



    setNisLoading(true);


    Get_Data_Tennis_Home_Ar()

  };

  useEffect(() => {


    setNisLoading(true);

    refda();
  }, [])





  const [JsonArray, setJsonArray] = React.useState([]);
  async function Get_Data_Tennis_Home_Ar() {

    JsonArray.splice(0);  //to clear All data in your page

    setNisLoading(true);

    axios.get(jsonbasket)

      .then(function (response) {
        setNisLoading(false);

        console.log(response.data);




        for (let i = 1; i <= 5 && i < response.data.length; i++) {

          JsonArray.push({

            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split(" ")[0],
            news_imagename: response.data[i].Image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),
            Category: response.data[i].Category,

          })
        }
      })
  }






  return (
    <>

      <div className="container custom-container">
        <div className="video-style-box mt-40">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <a href='Tennis_Ar'>
                  <h3 className="title float-right"> أخبار التنس  </h3>
                </a>
              </div>
            </div>
          </div>
          <div className="row pt-3">
            {/* main post o tennis */}
            <Tennis_Main_Ar />
            <div className="col-lg-6">
              {JsonArray.map(da =>

                <div key={da.news_title}  >
                  <div className="video-play-sidebar-items">
                    <div className="post-gallery-style-2">
                      <div className="post-gallery-thumb">
                        <a href={da.link}>

                          <img className='rounded' style={{ maxWidth: '100px', maxHeight: '70px', minWidth: '100px', minHeight: '70px' }} src={da.news_imagename} alt="gallery" />
                        </a>
                      </div>
                      <div className="post-gallery-content col-sm-8">
                        <h5 className="title"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h5>
                        <div className="meta-post-2-style">
                          <div class="meta-post-2-style">

                            <div class="meta-post-categores">
                              {/* <a href={da.link} tabindex="-1">{da.Category}</a> */}
                              <a href={da.link} tabindex="-1"><p>تنس</p></a>
                            </div>
                            <div class="meta-post-date">
                              {/* <span className=''>{new Date(da.news_date).toLocaleDateString('ar-GB')}</span> */}
                              <span>{new Date(da.news_date).toLocaleDateString('ar-EG')}</span>
                            </div>

                          </div>

                        </div>
                      </div>
                    </div>

                    <div ></div>



                  </div>

                </div>

              )}
            </div>

          </div>
        </div>
      </div>

    </>
  );
}



